import moment from "moment";

import { escapeHtml } from "@utils/sanitizeHtml";

import _ from "lodash";

export const convertKeysToCamelCase = (obj) => {
  if (_.isArray(obj)) {
    return obj.map((v) => convertKeysToCamelCase(v));
  } else if (_.isObject(obj) && obj !== null && !_.isDate(obj)) {
    return _.reduce(
      obj,
      (result, value, key) => {
        result[_.camelCase(key)] = convertKeysToCamelCase(value);
        return result;
      },
      {}
    );
  }
  return obj;
};

export const isEmptyObject = (obj) => Object.keys(obj).length === 0;

export const objectLength = (obj) => Object.keys(obj).length;

export const isAnyObjectValueEmpty = (obj) => {
  for (const key in obj) {
    if (
      Object.prototype.hasOwnProperty.call(obj, key) &&
      (obj[key] === null || obj[key] === undefined || obj[key] === "")
    ) {
      return true;
    }
  }
  return false;
};

export const convertToInternationalFormat = (number) => {
  // console.log('number', number)
  if (!number) return;
  if (number.startsWith("09")) {
    number =
      "+886 " +
      number.substring(1, 4) +
      "-" +
      number.substring(4, 7) +
      "-" +
      number.substring(7);
  }
  return number;
};

export const highlinePhone = (number, phoneValue) => {
  let formattedNumber = number;
  if (!formattedNumber) return;
  // 如果開頭是 0，則轉換為 +886
  if (formattedNumber.startsWith("0")) {
    formattedNumber = "+886" + formattedNumber.substring(1);
  }

  // 格式化電話號碼為 "+886 911-111-111" 形式
  formattedNumber = formattedNumber.replace(
    /^(\+886|0)?(\d{2,4})(\d{3})(\d{3})$/,
    (_, plus, area, first, second) => {
      return `${plus ? plus + " " : "+886 "}${area}-${first}-${second}`;
    }
  );

  const phoneValueString = String(phoneValue || "");
  if (!phoneValueString) {
    return <>{formattedNumber}</>;
  }

  const escapedValue = phoneValueString.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  const regex = new RegExp(escapedValue, "i");
  const match = formattedNumber.match(regex);

  if (match) {
    const index = match.index;
    const firstPart = formattedNumber.substring(0, index);
    const highlightedPart = formattedNumber.substring(
      index,
      index + phoneValue.length
    );
    const lastPart = formattedNumber.substring(index + phoneValue.length);

    return (
      <div>
        {firstPart}
        <span style={{ color: "#46A297" }}>{highlightedPart}</span>
        {lastPart}
      </div>
    );
  }

  return <>{formattedNumber}</>;
};

// 金額千分位（整數）
export function formatPrice(money) {
  let integer = parseInt(money);
  if (integer) {
    integer += "";
    var arr = integer.split(".");
    var re = /(\d{1,3})(?=(\d{3})+$)/g;
    return arr[0].replace(re, "$1,") + (arr.length === 2 ? "." + arr[1] : "");
  } else {
    return integer;
  }
}

export const priceWithDecimal = (money) => {
  let integer = money;
  if (integer) {
    // console.log(integer);
    integer += "";
    var arr = integer.split(".");
    // console.log(arr);
    var re = /(\d{1,3})(?=(\d{3})+$)/g;
    return arr[0].replace(re, "$1,") + (arr.length === 2 ? "." + arr[1] : "");
  } else {
    return integer;
  }
};

export const customSort = (arr, sortVariable, start) => {
  // console.log(arr, sortVariable, start)
  // 將陣列分為兩部分：大於等於起始數字的部分和小於起始數字的部分
  let greaterOrEqual = arr.filter((item) => item[sortVariable] >= start);
  let lessThan = arr.filter((item) => item[sortVariable] < start);

  // 對這兩部分分別進行升序排序
  greaterOrEqual.sort((a, b) => a[sortVariable] - b[sortVariable]);
  lessThan.sort((a, b) => a[sortVariable] - b[sortVariable]);

  // 將兩部分連接起來，形成從起始數字開始排序的陣列
  return [...greaterOrEqual, ...lessThan];
};

// 有「不限」時的多選狀態：「不限」跟其他多選只能選其一，除了「不限」以外的選項全選，自動變成「不限」
export const handleMultiSelectChange = (
  newValue,
  value,
  onChange,
  allOptions
) => {
  const lastSelected = newValue.find((v) => !value.includes(v));
  const otherOptions = allOptions
    .filter((opt) => opt.value !== "ALL")
    .map((opt) => opt.value);
  const currentSelectedNonAll = newValue.filter((v) => v !== "ALL");

  if (lastSelected === "ALL") {
    onChange(["ALL"]);
  } else if (value.includes("ALL")) {
    onChange(newValue.filter((v) => v !== "ALL"));
  } else if (currentSelectedNonAll.length === otherOptions.length) {
    onChange(["ALL"]);
  } else {
    onChange(newValue);
  }
};

// diff form
export const checkFormChanges = (currentData, defaultValues) => {
  return Object.keys(currentData).some((key) => {
    const currentValue = currentData[key];
    const defaultValue = defaultValues[key];

    if (!currentValue && !defaultValue) return false;

    if (Array.isArray(currentValue) && Array.isArray(defaultValue)) {
      if (currentValue.length === 0 && defaultValue.length === 0) return false;
      return JSON.stringify(currentValue) !== JSON.stringify(defaultValue);
    }
    return currentValue !== defaultValue;
  });
};

export const getValueByType = (type, value) => {
  switch (type) {
    case "PERCENTAGE":
      return value / 100;
    case "CASH":
      return value;
    default:
      return null;
  }
};

export const unixTimeToDate = (unixTime) => {
  if (!unixTime) return;
  if (typeof unixTime === "number") {
    return moment(new Date(unixTime * 1000)).format("YYYY 年 MM 月 DD 日");
  } else {
    return;
  }
};

// 測試
//   console.log(truncateText("This is a very long sentence that needs to be truncated.", 20)); // "This is a very long ..."

export const unixTimeToDateInSlash = (unixTime) => {
  if (!unixTime) return;
  if (typeof unixTime === "number") {
    return moment(new Date(unixTime * 1000)).format("YYYY/MM/DD");
  } else {
    return;
  }
};

export const unixTimeToDateTime = (unixTime) => {
  if (!unixTime) return;
  if (typeof unixTime === "number") {
    return moment(new Date(unixTime * 1000)).format(
      "YYYY 年 MM 月 DD 日 A hh:mm"
    );
  } else {
    return;
  }
};
export const stringToDateInSlash = (string) => {
  if (!string) return;
  if (typeof string === "string") {
    return moment(new Date(string)).format("YYYY/MM/DD");
  } else {
    return;
  }
};

export const stringToDateTime = (string) => {
  if (!string) return;
  if (typeof string === "string") {
    return moment(new Date(string)).format("YYYY 年 MM 月 DD 日 A hh:mm");
  } else {
    return;
  }
};

export const truncateText = (text, maxLength) => {
  if (typeof text !== "string") {
    return;
  }
  if (text.length <= maxLength) {
    return text;
  }
  return text.slice(0, maxLength) + "...";
};

// 測試
//   console.log(truncateText("This is a very long sentence that needs to be truncated.", 20)); // "This is a very long ..."

export const numberToChineseCapital = (num) => {
  if (typeof num !== "number") {
    return;
  }

  const units = ["", "拾", "佰", "仟"];
  const bigUnits = ["", "萬", "億", "兆"];
  const digits = "零壹貳參肆伍陸柒捌玖";
  const fraction = ["角", "分"];

  // 特殊情況：零元
  if (num === 0) return "零元整";

  let integerPart = Math.floor(num);
  let decimalPart = Math.round((num - integerPart) * 100);
  let result = "";

  // 處理小數部分
  if (decimalPart > 0) {
    let decimalStr = "";
    for (let i = 0; i < fraction.length; i++) {
      const digit = Math.floor(decimalPart / Math.pow(10, 1 - i)) % 10;
      if (digit !== 0) {
        decimalStr += digits[digit] + fraction[i];
      }
    }
    result = decimalStr;
  } else {
    result = "整";
  }

  // 處理整數部分
  let integerStr = "";
  let unitIndex = 0;
  let zeroCount = 0;
  while (integerPart > 0) {
    let part = "";
    for (let i = 0; i < 4; i++) {
      const digit = integerPart % 10;
      if (digit === 0) {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          part = digits[0] + part;
        }
        part = digits[digit] + units[i] + part;
        zeroCount = 0;
      }
      integerPart = Math.floor(integerPart / 10);
      if (integerPart === 0) break;
    }
    if (part !== "") {
      integerStr = part + bigUnits[unitIndex] + integerStr;
    }
    unitIndex++;
  }

  return integerStr + "元" + result;

  // 測試
  // console.log(numberToChineseCapital(6300)); // 陸仟參佰元整
  // console.log(numberToChineseCapital(12345678.90)); // 壹仟貳佰參拾肆萬伍仟陸佰柒拾捌元玖角
};

export const discountTypeToString = (type, value) => {
  switch (type) {
    case "CASH":
      return "現金折價";
    case "PERCENTAGE":
      if ((value * 100) % 10) {
        return `折數${Math.floor(value * 100)}折`;
      } else {
        return `折數${Math.floor(value * 10)}折`;
      }
    default:
      return "";
  }
};

export const isInvoiceCarrierValid = (carrier) => {
  const carrierRegex = /^\/[A-Za-z0-9+.-]{7}$/;
  // const mobileBarcodeRegex = /^\/[\w.-]{7}$/; // 手機條碼
  // const membershipCarrierRegex = /^[A-Z0-9]{10,16}$/; // 會員載具 (假設10-16碼英數)
  if (carrierRegex.test(carrier)) {
    // return 'Mobile Barcode'; // 手機條碼
    return true;
  } else {
    // return 'In valid Carrier'; // 無效載具
    return false;
  }
  // // 範例使用
  // console.log(validateInvoiceCarrier('/AB12345')); // 輸出: Mobile Barcode
  // console.log(validateInvoiceCarrier('A123456789')); // 輸出: Membership Carrier
  // console.log(validateInvoiceCarrier('123')); // 輸出: Invalid Carrier
};

export const isTaxIdNumberValid = (taxIdNumber) => {
  // 驗證是否為 8 位數字
  const ubnRegex = /^\d{8}$/;
  return ubnRegex.test(taxIdNumber) ? true : false;
};

export const objectToQueryString = (params) => {
  return (
    "?" +
    Object.entries(params)
      .map(([key, value]) => `${key}=${value}`)
      .join("&")
  );
};
// // 測試
// const input = { userId: 1123, branchId: 3 };
// const queryString = objectToQueryString(input);
// console.log(queryString); // 輸出: "?userId='1123'&branchId='3'"

// 顧客相簿 - 格式化時間
export const formatDateToString = (dateStr) => {
  // 創建日期對象
  const date = new Date(dateStr);

  // 使用 Intl.DateTimeFormat 格式化日期
  const formatter = new Intl.DateTimeFormat('zh-TW', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });

  // 格式化日期
  const formattedDate = formatter.format(date);

  // 拆分格式化後的日期並重新組合
  let [year, month, day] = formattedDate.split('/');
  // 如果月份是一位數，前面加零
  month = month.padStart(2, '0');
  day = day.padStart(2, '0');

  const customFormattedDate = `${year}-${month}-${day}`;

  return customFormattedDate;
}

// 格式化日期，月份前面不加 0
export const formatDateToCustomString = (dateStr) => {
  // 創建日期對象
  const date = new Date(dateStr);

  // 使用 Intl.DateTimeFormat 格式化日期
  const formatter = new Intl.DateTimeFormat('zh-TW', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric'
  });

  // 格式化日期
  const formattedDate = formatter.format(date);

  // 拆分格式化後的日期並重新組合
  let [year, month, day] = formattedDate.split('/');
  const customFormattedDate = `${year}年 ${month}月 ${day}日`;

  return customFormattedDate;
}

// 數字轉國字大寫
export const numberToChinese = (num) => {
  const chineseDigits = ['零', '壹', '貳', '參', '肆', '伍', '陸', '柒', '捌', '玖'];
  const chineseUnits = ['', '拾', '佰', '仟'];
  const chineseBigUnits = ['', '萬', '億', '兆'];
  
  if (num === 0) return '零元整';
  
  const isNegative = num < 0;
  num = Math.abs(Math.round(num));
  
  if (num === 0) return '零元整';
  
  let result = '';
  let unitIndex = 0;
  
  while (num > 0) {
    const section = num % 10000;
    if (section > 0) {
      let sectionStr = '';
      let sectionNum = section;
      let digitIndex = 0;
      let hasZero = false;
      
      while (sectionNum > 0) {
        const digit = sectionNum % 10;
        if (digit === 0) {
          if (sectionStr && !hasZero) {
            hasZero = true;
          }
        } else {
          if (hasZero) {
            sectionStr = chineseDigits[0] + sectionStr;
            hasZero = false;
          }
          sectionStr = chineseDigits[digit] + chineseUnits[digitIndex] + sectionStr;
        }
        sectionNum = Math.floor(sectionNum / 10);
        digitIndex++;
      }
      
      result = sectionStr + chineseBigUnits[unitIndex] + result;
    } else if (result && unitIndex > 0) {
      // 處理中間有零的情況
      if (!result.startsWith(chineseDigits[0])) {
        result = chineseDigits[0] + result;
      }
    }
    
    num = Math.floor(num / 10000);
    unitIndex++;
  }
  
  // 清理多餘的零
  result = result.replace(/零+/g, '零').replace(/零+$/, '');
  
  return (isNegative ? '負' : '') + '新台幣' + result + '元整';
};

/**
 * 台灣縣市總表
 * @description 用於驗證從地址解析出的縣市是否為有效的台灣行政區
 */
export const TAIWAN_CITIES = [
  // 6 直轄市
  '台北市', '臺北市',
  '新北市',
  '桃園市',
  '台中市', '臺中市',
  '台南市', '臺南市',
  '高雄市',
  // 3 省轄市
  '基隆市',
  '新竹市',
  '嘉義市',
  // 13 縣
  '新竹縣',
  '苗栗縣',
  '彰化縣',
  '南投縣',
  '雲林縣',
  '嘉義縣',
  '屏東縣',
  '宜蘭縣',
  '花蓮縣',
  '台東縣', '臺東縣',
  '澎湖縣',
  '金門縣',
  '連江縣',
];

/**
 * 從地址中解析出縣市名稱
 * @param {string} address - 分店地址
 * @param {string} fallback - 找不到時的預設值，預設為「台北市」
 * @returns {string} 縣市名稱（如：台北市、新北市、桃園縣）
 * 
 * @example
 * extractCityFromAddress("台北市中山區南京東路一段46號7樓") // "台北市"
 * extractCityFromAddress("新北市板橋區中山路一段1號") // "新北市"
 * extractCityFromAddress("some invalid address") // "台北市" (fallback)
 */
export const extractCityFromAddress = (address, fallback = '台北市') => {
  if (!address || typeof address !== 'string') {
    return fallback;
  }

  // 嘗試匹配「XX市」或「XX縣」（取前3個字）
  const match = address.match(/^(.{2}[市縣])/);
  
  if (match) {
    const city = match[1];
    // 驗證是否為有效的台灣縣市
    if (TAIWAN_CITIES.includes(city)) {
      return city;
    }
  }

  return fallback;
};
